import { DEFAULT_LITTER_INITAL_VALUES } from '@application/components/controllers/pages/MtLitterPageController/api/useLitterIntialValuesBuilder';
import type { MtLitterPageFormValues } from '@presentation/pages';
import { atom, useRecoilState } from 'recoil';

export interface MtLitterFormState {
  values?: MtLitterPageFormValues;
  litterId?: number | 'new';
  mode?: 'edit' | 'new' | 'view';
}

export const mtLitterFormState = atom<MtLitterFormState>({
  key: 'mtLitterFormState',
  default: {
    litterId: undefined,
    values: DEFAULT_LITTER_INITAL_VALUES,
    mode: undefined,
  },
});

export const useLitterFormState = () => {
  const [litterFormState, setLitterFormState] = useRecoilState(mtLitterFormState);

  return { litterFormState, setLitterFormState };
};
